import {
  IOverlayParameter,
  IResult,
  IHeatParameter,
  IHeatPoint,
  ILayerConfig
} from "@/types/map";
import {loadModules} from "esri-loader";
import Axios from "axios";
import {resolve} from "esri/core/promiseUtils";
import {param} from "jquery";
import {XMLUtils} from "./XMLUtils";
export class XMLLayer {
  private static intances: Map<string, any>;
  private view!: any;
  private constructor(view: any) {
    this.view = view;
  }
  public static getInstance(view: __esri.MapView) {
    let id = view.container.id;
    if (!XMLLayer.intances) {
      XMLLayer.intances = new Map();
    }
    let intance = XMLLayer.intances.get(id);
    if (!intance) {
      intance = new XMLLayer(view);
      XMLLayer.intances.set(id, intance);
    }
    return intance;
  }
  public static destroy() {
    (XMLLayer.intances as any) = null;
  }
  public async addXMLLayer(params: any) {
    type MapModules = [
      typeof import("esri/layers/FeatureLayer"),
      typeof import("esri/Graphic")
    ];
    const [FeatureLayer, Graphic] = await (loadModules([
      "esri/layers/FeatureLayer",
      "esri/Graphic"
    ]) as Promise<MapModules>);
    let xmlResult = await this.queryXML(params.url);
    if (xmlResult.length == 0) {
      return;
    }
    let node = xmlResult[0];
    let fields: any[] = [];
    fields.push({name: "OBJECTID", type: "oid"});
    for (let field in node) {
      fields.push({name: field, type: "string"});
    }
    let xField =
      params.option && params.option.xField ? params.option.xField : "cjX";
    let yField =
      params.option && params.option.yField ? params.option.yField : "cjY";
    let graphics = xmlResult.map((item: any) => {
      //如果存在城建坐标,使用坐标替换
      if (
        !this.view.spatialReference.isWGS84 &&
        !this.view.spatialReference.isWebMercator
      ) {
        return new Graphic({
          geometry: {
            type: "point",
            x: item[xField],
            y: item[yField],
            spatialReference: this.view.spatialReference
          } as any,
          attributes: item
        });
      } else {
        return new Graphic({
          geometry: {
            type: "point",
            x: item[xField],
            y: item[yField]
          } as any,
          attributes: item
        });
      }
    });
    let layerConfig = params;
    delete layerConfig.url;
    let layer = new FeatureLayer({
      source: graphics,
      objectIdField: "OBJECTID",
      geometryType: "point",
      spatialReference: this.view.spatialReference,
      fields: fields,
      ...params
    });
    if (params.layerIndex) {
      this.view.map.add(layer, params.layerIndex);
    } else {
      this.view.map.add(layer);
    }
  }
  public async queryXML(url: string) {
    // let testString = (await Axios.get(url)).data;
    let result: any = (await Axios.get(url)).data;
    if (result) {
      return result;
    } else {
      return [];
    }
  }
}
